/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class FormContainerModel {
        public containers: Wars.Domain.Model.FormContainer[];
        public currentContainer: Wars.Domain.Model.FormContainer;
        public forms: Wars.Domain.Model.Form[];
        public formContainerAssociations: Wars.Domain.Model.FormContainerAssociation[];

        constructor(private formContainerService: services.FormContainerService,
            private formService: services.FormService,
            private deleteService: services.DeleteService,
            private systemLevelService: services.SystemLevelService,
            private securityMatrixService: services.SecurityMatrixService,
            private processConfigurationId: string) {

            this.formContainerService.getAllFormContainersForProcessConfiguration(processConfigurationId)
                .then(containers => {
                    this.containers = containers;
                });

            this.formService.getProcessConfigurationForms(processConfigurationId).then(forms => {
                this.forms = forms;
            });

            this.systemLevelService.getSystemLevelFormContainerAssociations().then((sysLevel) => {
                this.formContainerAssociations = sysLevel.myFormContainerAssociations;
            });
        }

        public containerOrderDown(formContainer: Wars.Domain.Model.FormContainer) {
            const newPosition = formContainer.displayOrder + 1;

            var oldFormContainer = Enumerable.from(this.containers).singleOrDefault(c => c.displayOrder == newPosition);

            if (oldFormContainer) {
                oldFormContainer.displayOrder--;
                formContainer.displayOrder++;
            }

            this.save();
        }

        public containerOrderUp(formContainer: Wars.Domain.Model.FormContainer) {
            const newPosition = formContainer.displayOrder - 1;

            var oldFormContainer = Enumerable.from(this.containers).singleOrDefault(c => c.displayOrder == newPosition);

            if (oldFormContainer) {
                oldFormContainer.displayOrder++;
                formContainer.displayOrder--;
            }

            this.save();
        }

        public containerItemOrderDown(item: Wars.Domain.Model.FormContainerItem) {
            const newPosition = item.displayOrder + 1;

            var oldItem = Enumerable.from(this.currentContainer.containerItems).singleOrDefault(c => c.displayOrder == newPosition);

            if (oldItem) {
                oldItem.displayOrder--;
                item.displayOrder++;
            }

            this.save();
        }

        public containerItemOrderUp(item: Wars.Domain.Model.FormContainerItem) {
            const newPosition = item.displayOrder - 1;

            var oldItem = Enumerable.from(this.currentContainer.containerItems).singleOrDefault(c => c.displayOrder == newPosition);

            if (oldItem) {
                oldItem.displayOrder++;
                item.displayOrder--;
            }

            this.save();
        }

        public addFormContainer() {
            this.currentContainer = this.formContainerService.createFormContainer();
            this.currentContainer.displayOrder = this.containers.length + 1;
            this.currentContainer.name = "New Container";
            this.currentContainer.uniqueIdentifier = services.UtilityService.generateGuidComb();
            this.currentContainer.securityMatrix = this.securityMatrixService.createSecurityMatrix(false, true);
            this.currentContainer.securityMatrix_id = this.currentContainer.securityMatrix.id;
            this.currentContainer.processConfiguration_id = this.processConfigurationId;

            this.containers.push(this.currentContainer);
            this.save();
        }

        public addItem() {
            let newItem = this.formContainerService.createFormContainerItem();
            newItem.displayOrder = this.currentContainer.containerItems.length + 1;

            this.currentContainer.containerItems.push(newItem);
            this.save();
        }

        public manageSecurityMatrix() : void {
            if (!this.currentContainer.securityMatrix_id) {
                this.currentContainer.securityMatrix = this.securityMatrixService.createSecurityMatrix(false, true);
                this.currentContainer.securityMatrix_id = this.currentContainer.securityMatrix.id;
                this.save();
            }
            this.securityMatrixService.openSecurityMatrixModal(this.currentContainer.securityMatrix, this.processConfigurationId);
        }

        public save() {
            this.formContainerService.saveAllChanges();
        }

        public deleteContainerItem(item: Wars.Domain.Model.FormContainerItem) {
            item.entityAspect.setDeleted();

            this.currentContainer.containerItems.forEach(c => {
                if (c.displayOrder > item.displayOrder) {
                    c.displayOrder--;
                }
            });

            this.save();
        }

        public deleteFormContainer() {
            this.deleteService.deleteWithModalConfirmIfNecessary("FormContainer",
                this.currentContainer.id,
                "Form Container",
                () => {
                    this.containers.remove(this.currentContainer);

                    this.containers.forEach(c => {
                        if (c.displayOrder>this.currentContainer.displayOrder) {
                            c.displayOrder--;
                        }
                    });

                    this.save();
                    this.currentContainer = null;
                });
        }
    }
}